<template>
  <div class="flex align-items-center gap-4">
    <div class="flex flex-column align-items-start gap-1">
      <label>Min</label>
      <Dropdown
        :model-value="modelValue[0]"
        :options="minFrequencyOptions"
        append-to="body"
        @change="emit('update:model-value', [$event.value, modelValue[1]])"
      />

      <div v-for="pole in motorPoles" :key="`min-${pole}`" class="mt-2">
        <span v-if="pole > 2">
          {{ pole }} Poles Min:
          {{ calcMotorPoleFrequency(modelValue[0], pole) }} Hz
        </span>
      </div>
    </div>

    <div class="flex flex-column align-items-start gap-1">
      <label>Max</label>
      <Dropdown
        :model-value="modelValue[1]"
        :options="maxFrequencyOptions"
        append-to="body"
        @change="emit('update:model-value', [modelValue[0], $event.value])"
      />

      <div v-for="pole in motorPoles" :key="`max-${pole}`" class="mt-2">
        <span v-if="pole > 2">
          {{ pole }} Poles Max:
          {{ calcMotorPoleFrequency(modelValue[1], pole) }} Hz
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

const props = defineProps<{
  modelValue: [number, number];
  motorPoles: number[];
}>();

const emit = defineEmits(["update:model-value"]);

const step = ref(5);
const min = ref(30);
const max = ref(80);

const minFrequencyOptions = computed(() => {
  return Array.from(
    { length: (props.modelValue[1] - min.value) / step.value },
    (_, i) => i * step.value + min.value
  );
});

const maxFrequencyOptions = computed(() => {
  return Array.from(
    { length: (max.value - props.modelValue[0]) / step.value },
    (_, i) => (i + 1) * step.value + props.modelValue[0]
  );
});

const calcMotorPoleFrequency = (frequency: number, poles: number) => {
  return (frequency * (poles / 2)).toFixed(0).toString();
};
</script>
